/**
 * Time Navigation Configuration
 *
 * Parameters for time navigation buttons in planet drag overlay
 */

export interface TimeNavigationConfig {
  // Degree steps for navigation
  defaultStepDegrees: number;     // Default step size (1 degree)
  shiftMultiplier: number;        // Multiplier for Shift key (10x)
  minStepDegrees: number;         // Minimum step (0.001 degree)
  maxStepDegrees: number;         // Maximum step (10 degrees)

  // Buffer range (how many degrees to load from API)
  bufferRangeDegrees: number;     // ±360 degrees from current position

  // Auto-repeat when holding button
  holdRepeatDelayMs: number;      // Initial delay before repeat starts
  holdRepeatIntervalMs: number;   // Interval between repeats

  // Visual
  buttonSize: number;             // Button size in pixels
}

export const timeNavigationConfig: TimeNavigationConfig = {
  // Degree steps
  defaultStepDegrees: 1,
  shiftMultiplier: 10,            // Shift = 10 steps
  minStepDegrees: 0.001,
  maxStepDegrees: 10,

  // Buffer range
  bufferRangeDegrees: 360,

  // Auto-repeat timing
  holdRepeatDelayMs: 500,         // 0.5 sec before repeat starts
  holdRepeatIntervalMs: 500,      // 0.5 sec between repeats

  // Visual
  buttonSize: 36,
};

export default timeNavigationConfig;
